module.exports = __webpack_public_path__ + "img/over.7e6301b6.png";